import { render, staticRenderFns } from "./view-lost-found.vue?vue&type=template&id=4ba41150&"
import script from "./view-lost-found.vue?vue&type=script&lang=ts&"
export * from "./view-lost-found.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports